import {delegate} from '../../utils/delegate'

delegate('click', '.review__video-overlay', (event,elem) => {
    elem.classList.add('hidden')
    let video = elem.nextElementSibling
    console.dir(video)
    video.controls = true
    video.play()
})